export const tr = {
    'are-you-sure-to-apply-many-campaigns': '{count} kampanya değiştirilecek. Öneri uygulansın mı?',
    'are-you-sure-to-apply-many-groups': '{count} grup değiştirilecek. Öneri uygulansın mı?',
    'are-you-sure-to-apply-one-campaigns': '{count} kampanya değiştirilecek. Öneri uygulansın mı?',
    'are-you-sure-to-apply-one-groups': '{count} reklam grubu değiştirilecek. Öneri uygulansın mı? ',
    'are-you-sure-to-apply-some-campaigns': '{count} kampanya değiştirilecek. Öneri uygulansın mı?',
    'are-you-sure-to-apply-some-groups': '{count} reklam grubu değiştirilecek. Öneri uygulansın mı?',
    'autotargeting-context-result': '"{name}" reklam grubu için otomatik hedefleme etkinleştirildi',
    'autotargeting-context-result-error': '"{name}" reklam grubu için otomatik hedefleme etkinleştirilemedi',
    'autotargeting-context-result-error-with-refresh':
        '"{name}" reklam grubu için otomatik hedefleme etkinleştirilemedi. Sayfayı yenileyin',
    'autotargeting-grid-result': '"{name}" reklam grubu için otomatik hedefleme etkinleştirildi',
    'autotargeting-grid-result-error': '"{name}" reklam grubu için otomatik hedefleme etkinleştirilemiyor',
    'autotargeting-grid-result-error-with-refresh':
        '"{name}" reklam grubu için otomatik hedefleme etkinleştirilemiyor. Sayfayı yenileyin',
    banner: 'reklam №{id}',
    'banner-title': {
        one: 'Reklamlarınızı iyileştirmek için {count} öneri',
        some: 'Reklamlarınızı iyileştirmek için {count} öneri',
        many: 'Reklamlarınızı iyileştirmek için {count} öneri',
        none: 'Reklamlarınızı iyileştirmek için {count} öneri'
    },
    campaign: 'kampanya №{id}',
    'campaign-budget-context-result': '"{name}" kampanyasının bütçe limiti artırıldı',
    'campaign-budget-context-result-error': '"{name}" kampanyası için bütçe limiti yükseltilemiyor',
    'campaign-budget-context-result-error-with-refresh':
        '"{name}" kampanyası için bütçe limiti yükseltilemiyor. Sayfayı yenileyin',
    'campaign-budget-grid-result': '"{name}" kampanyasının bütçe limiti yükseltildi',
    'campaign-budget-grid-result-error': '"{name}" kampanyasının bütçe limiti yükseltilemedi',
    'campaign-budget-grid-result-error-with-refresh':
        '"{name}" kampanyasının bütçe limiti yükseltilemedi. Sayfayı yenileyin',
    'campaign-title': {
        one: 'Reklam kampanyanızın performansını artıracak {count} öneri',
        some: 'Reklam kampanyanızın performansını artıracak {count} öneri',
        many: 'Reklam kampanyanızın performansını artıracak {count} öneri',
        none: 'Reklam kampanyanızın performansını artıracak {count} öneri'
    },
    'error-autotargeting': 'Otomatik hedefleme etkinleştirilemedi',
    'error-autotargeting-with-refresh': 'Otomatik hedefleme etkinleştirilemedi. Sayfayı yenileyin',
    'error-campaign-budget': 'Bütçe limiti yükseltilemedi',
    'error-campaign-budget-with-refresh': 'Bütçe limiti yükseltilemedi. Sayfayı yenileyin',
    'error-fobidden-pages': 'Yüksek kaliteli sitelerde gösterimler etkinleştirilemedi',
    'error-fobidden-pages-with-refresh': 'Yüksek kaliteli sitelerde gösterimler etkinleştirilemedi. Sayfayı yenileyin',
    'fobidden-pages-context-result': 'Yüksek kaliteli "{name}" sitesinde gösterimler etkinleştirildi',
    'fobidden-pages-context-result-error': 'Yüksek kaliteli "{name}" sitesinde gösterimler etkinleştirilemedi',
    'fobidden-pages-context-result-error-with-refresh':
        'Yüksek kaliteli "{name}" sitesinde gösterimler etkinleştirilemedi. Sayfayı yenileyin',
    'fobidden-pages-grid-result': '"{name}" kampanyası için yüksek kaliteli sitelerde gösterimler etkinleştirildi',
    'fobidden-pages-grid-result-error':
        '"{name}" kampanyası için yüksek kaliteli sitelerde gösterimler etkinleştirilemiyor',
    'fobidden-pages-grid-result-error-with-refresh':
        '"{name}" kampanyası için yüksek kaliteli sitelerde gösterim etkinleştirilemedi. Sayfayı yenileyin ',
    'general-context-result': 'Öneri uygulandı',
    'general-context-result-error': 'Öneri uygulanmadı. Hata oluştu',
    'general-grid-result': 'Öneri uygulandı',
    'general-grid-result-error': 'Öneri uygulanırken hata oluştu',
    group: 'grup №{id}',
    'group-title': {
        one: 'Reklam grubunuzun performansını artıracak {count} öneri',
        some: 'Reklam grubunuzun performansını artıracak {count} öneri',
        many: 'Reklam grubunuzun performansını artıracak {count} öneri',
        none: 'Reklam grubunuzun performansını artıracak {count} öneri'
    },
    'many-items-full-autotargeting-result': '{count} reklam grubu için otomatik hedefleme etkinleştirildi',
    'many-items-full-campaign-budget-result': '{count} kampanya için bütçe limiti yükseltildi',
    'many-items-full-fobidden-pages-result': '{count} kampanya için yüksek kaliteli sitelerde gösterim etkinleştirildi',
    'many-items-full-general-result': 'Öneri, {count} öğeye uygulandı',
    'many-items-partial-autotargeting-result': 'Otomatik hedefleme {count} / {total} grup için etkinleştirildi',
    'many-items-partial-campaign-budget-result': 'Bütçe limiti {count} / {total} kampanya için yükseltildi',
    'many-items-partial-fobidden-pages-result':
        '{count} / {total} kampanya için yüksek kaliteli sitelerde gösterimler etkinleştirildi',
    'many-items-partial-general-result': 'Öneri {count} / {total} öğeye uygulandı',
    'one-item-full-autotargeting-result': 'Otomatik hedefleme {count} grup için etkinleştirildi',
    'one-item-full-campaign-budget-result': '{count} kampanya için bütçe limiti yükseltildi',
    'one-item-full-fobidden-pages-result':
        '{count} kampanya için yüksek kaliteli sitelerde gösterimler etkinleştirildi',
    'one-item-full-general-result': 'Öneri {count} öğeye uygulandı',
    'one-item-partial-autotargeting-result': '{count} / {total} grup için otomatik hedefleme etkinleştirildi',
    'one-item-partial-campaign-budget-result': '{count} / {total} kampanya için bütçe limiti yükseltildi',
    'one-item-partial-fobidden-pages-result':
        '{count} / {total} kampanya için yüksek kaliteli sitelerde gösterimler etkinleştirildi',
    'one-item-partial-general-result': 'Öneri, {count} / {total} öğeye uygulandı',
    'some-items-full-autotargeting-result': 'Otomatik hedefleme {count} grup için etkinleştirildi',
    'some-items-full-campaign-budget-result': 'Bütçe limiti {count} kampanya için yükseltildi',
    'some-items-full-fobidden-pages-result':
        '{count} kampanya için yüksek kaliteli sitelerde gösterimler etkinleştirildi',
    'some-items-full-general-result': 'Öneri {count} öğeye uygulandı',
    'some-items-partial-autotargeting-result': 'Otomatik hedefleme {count} / {total} grup için etkinleştirildi',
    'some-items-partial-campaign-budget-result': 'Bütçe limiti {count} / {total} kampanya için yükseltildi',
    'some-items-partial-fobidden-pages-result':
        '{count} / {total} kampanya için yüksek kaliteli sitelerde gösterimler etkinleştirildi',
    'some-items-partial-general-result': 'Öneri, {count} / {total} öğeye uygulandı',
    title: {
        one: '{count} öneri',
        some: '{count} öneri',
        many: '{count} öneri',
        none: '{count} öneri'
    }
};
